export * from './personalization.component';
